export const USER_REQUEST_CATEGORY = {
  CREATE: 1,
  UPDATE: 2,
} as const;
